<!-- Two shells, one body.
     * Bot scope runs as a child of /tutors/:tutorId and MUST keep the tutor
       shell — left menu column, content card on the right — exactly like
       Allgemein / KI-Konfiguration / Wissensbasis. Rendering a standalone
       page there would drop the menu and break navigation mid-flow.
     * Client scope is a top-level page and follows the page-header
       convention (h2 + subtitle outside the card). -->
<!-- Embedded = a tab of "Verhalten & Fähigkeiten" (/agent-setup/guardrails,
     /tutors/:id/setup/guardrails): the host owns header, card and tutor menu. -->
<ng-container *ngIf="embedded; else standalone">
  <ng-container *ngTemplateOutlet="body"></ng-container>
</ng-container>

<ng-template #standalone>
<ng-container *ngIf="scope === 'bot'; else clientShell">
  <app-tutor-menu>
    <nb-card>
      <nb-card-header>
        <h4>{{ "pages.guardrails.title" | translate }}</h4>
        <p class="section-card__desc">
          {{ "pages.guardrails.subtitleBot" | translate }}
        </p>
      </nb-card-header>
      <nb-card-body>
        <ng-container *ngTemplateOutlet="body"></ng-container>
      </nb-card-body>
    </nb-card>
  </app-tutor-menu>
</ng-container>

<ng-template #clientShell>
  <div class="page">
    <div class="header">
      <div>
        <h2>{{ "pages.guardrails.title" | translate }}</h2>
      </div>
      <app-page-help>{{ "pages.guardrails.subtitle" | translate }}</app-page-help>
    </div>

    <nb-card>
      <nb-card-body>
        <ng-container *ngTemplateOutlet="body"></ng-container>
      </nb-card-body>
    </nb-card>
  </div>
</ng-template>
</ng-template>

<ng-template #body>
  <div class="scope-bar">
    <span class="scope-note">
      {{
        (scope === "bot"
          ? "pages.guardrails.scopeNoteBot"
          : "pages.guardrails.scopeNote"
        ) | translate
      }}
      <a *ngIf="scope === 'bot'" routerLink="/guardrails">
        {{ "pages.guardrails.manageOrgRules" | translate }}
      </a>
    </span>
    <span *ngIf="rulesTruncated" class="truncation-note">
      {{
        "pages.guardrails.truncated"
          | translate: { shown: rules.length, total: total }
      }}
    </span>
  </div>

  <!-- Shared search field (same component as the KB and agent pages).
       `app-table` has no search of its own, so the page filters. -->
  <div class="search-bar" *ngIf="rules.length > 0">
    <app-search-input
      [(value)]="searchText"
      (valueChange)="onSearchChange()"
      placeholderKey="pages.guardrails.searchPlaceholder"
    ></app-search-input>
  </div>

  <!-- Shared table component (design: reuse over rebuild). Sorting, paging,
       the empty row and the per-row action menu — including the disabled
       state for inherited organisation rules — all come from it. -->
  <app-table
    rowIdKey="id"
    [nbSpinner]="isLoading"
    [title]="''"
    [columns]="columns"
    [data]="filteredRules"
    [rowActions]="rowActions"
    [globalActions]="globalActions"
    [maxVisibleItems]="pageSize"
    [options]="{ resetPageOnDataChange: false }"
    (event)="onTableEvent($event)"
  ></app-table>
</ng-template>
